import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

export function useSilkBalance(enabled = true) {
  return useQuery({
    queryKey: ['silk-balance'],
    queryFn: async () => {
      const { data } = await api.get<{ status: string; silk_own: number | null }>('/api/v1/home/silk-balance');
      return data.silk_own;
    },
    enabled,
    staleTime: 0,
  });
}
